import { LOGIN, LOGOUT, USER_INFO, RESET_FORM } from "app/auth/constants";
import decodeToken from "jwt-decode";

const initialState = {
  isAuthenticated: false,
  users: {},
  loginFailedMsg: null,
  redirectToReferrer: false
};

const handleLogin = (state, action) => {
  const { users } = state;
  const token = action.data.token;
  const user = decodeToken(token);
  const {
    email,
    fullName,
    screenName,
    sub,
    role = user.orgRoles[Object.keys(user.orgRoles)[0]]
  } = user;
  user.name = screenName || fullName || email || sub;
  // Temporary workaround for user-service bug.
  user.admin = role === "topic-moderator" || role === "admin" ? true : false;
  return {
    users,
    isAuthenticated: true,
    user,
    token,
    userId: sub,
    loginFailedMsg: null,
    redirectToReferrer: true
  };
};

const handleLogout = (state, action) => {
  const { users } = state;
  return { ...initialState, users };
};

const handleUserInfo = (state, action) => {
  const { type, payload, data } = action;
  const { users } = state;
  const userId = payload.params.userId;
  const prevUser = users[userId];
  const isSuccess = type === USER_INFO.SUCCESS;
  const user = {
    ...(isSuccess ? data : prevUser),
    [type]: data
  };
  return { ...state, users: { ...users, [userId]: user } };
};

const handleLoginFailed = (state, action) => {
  const { data } = action;
  return { ...state, loginFailedMsg: data.message, isAuthenticated: false };
};

const handleResetForm = state => {
  return {
    ...state,
    ...initialState
  };
};

const reducers = {
  [RESET_FORM]: handleResetForm,
  [LOGIN.SUCCESS]: handleLogin,
  [LOGIN.ERROR]: handleLoginFailed,
  [LOGOUT]: handleLogout,
  [USER_INFO.PENDING]: handleUserInfo,
  [USER_INFO.SUCCESS]: handleUserInfo,
  [USER_INFO.ERROR]: handleUserInfo
};

export default (state = initialState, action) => {
  const { type } = action;
  const handler = reducers[type];
  if (handler) {
    return handler(state, action);
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/app/auth/reducers.js